import { Component, OnInit } from '@angular/core';
import { ApiService } from "../../services/api.service";
import { PopoverController } from '@ionic/angular';
import { SearchciudadesPage } from '../searchciudades/searchciudades.page';

@Component({
  selector: 'app-editemp',
  templateUrl: './editemp.page.html',
  styleUrls: ['./editemp.page.scss'],
})

export class EditempPage implements OnInit {

  editSalario = this.api.verRol('editSalario');
  editVariable = this.api.verRol('editVariable');
  editDescuentos = this.api.verRol('editDescuentos');
  editPeriodo = this.api.verRol('editPeriodo');
  editEmpleador = this.api.verRol('editEmpleador');
  editLinea = this.api.verRol('editLinea');
  editTipoContrato = this.api.verRol('editTipoContrato');
  editEmailReg = this.api.verRol('editEmailReg');
  editCelularReg = this.api.verRol('editCelularReg');
  editCodigoCargo = this.api.verRol('editCodigoCargo');

  constructor(
    public api:ApiService,
    public popoverController: PopoverController
  ) { }

  ngOnInit() {}

  async searchCiudades(val:any, newEmp:any) {
     this.api.ciudadValue = val;
     this.api.isNewEmp = newEmp;
     this.api.updateFilterCiudad(this.api.busquedaCiu);
     const popover = await this.popoverController.create({
       component: SearchciudadesPage,
       cssClass: 'popoverStyle4',
       /* event: ev, */
       translucent: true,
       componentProps: {},
       mode: 'ios'
     });
     return await popover.present();
   }
}